module.exports = __webpack_public_path__ + "static/media/jacketW.b614dc8a.webp";